<template>
    <div id="KpiJobStaffComponent" class="row">
        <div class="w-100">
            <div id="" class="panel-container show ml-2">
                <div class="m-2">
                    <div class="ml-3 d-flex justify-content-between">
                        <b style="color: rgba(18, 0, 219, 1);">Điểm KPI tổng: {{
                                data?.total_percent_kra > 0 && data?.total_percent_kra !== null ? data?.total_percent_kra + '%' : 'Chưa có'
                            }}</b>
                        <div class="text-danger mr-4">
                            Lưu ý: Nhân sự cần mở quyền truy cập bảng thành phẩm cho teamlead và email hanhchinh@edutalkvn.com.
                        </div>
                    </div>
                    <div>
                        <div class="card-body">
                            <div class="example mb-10">
                                <div class="row filter_form">
                                </div>
                                <div class="example-preview table-responsive">
                                    <table v-loading="loading" class="table table-vertical-center table-bordered"
                                           element-loading-text="Loading...">
                                        <thead>
                                        <tr style="background-color: #F8F8F8;">
                                            <th class="header-kra">KRAs</th>
                                            <th class="header-kra">Yêu cầu thành phẩm</th>
                                            <th class="header-kra">Nhập thành phẩm</th>
                                            <th class="header-kra" style="width:8%">Trọng số</th>
                                            <th class="header-kra">Trạng thái</th>
                                            <th class="header-kra">Kết quả KRA</th>
                                            <th class="header-kra" style="width:6%">Hành động</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                            <template v-if="data?.details?.data">
                                                <tr v-for="item in data?.details?.data" :key="item.id">
                                                    <td>
                                                        <div class="breaking-text">{{ item.name.trim() ?? '' }}</div>
                                                    </td>
                                                    <td>
                                                        <div class="breaking-text">{{ item.request_result.trim() ?? '' }}</div>
                                                    </td>
                                                    <td style=" width:25%">
                                                        <div class="d-flex">
                                                            <el-input placeholder="Bạn có thể nhập thành phẩm tại đây." type="textarea"
                                                                      :rows="2" v-model="item.results" @input="clearResult();debouncedChangeResult(item, item.results, item.id)"></el-input>
                                                        </div>
                                                        <div class="text-danger mt-2" v-if="resultsError[item.id]">{{ resultsError[item.id] }}</div>
                                                        <div class="text-success mt-2" v-if="resultsSuccess[item.id]">{{ resultsSuccess[item.id] }}</div>
                                                    </td>
                                                    <td> {{ item.percent_score + '%' ?? '' }}</td>
                                                    <td style="text-align:-webkit-center; width:6%">
                                                        <div :style="statusKpiCss[item.status]" class="text-white rounded p-1 text-center"
                                                             style="width:100px"> {{ statusKpi[item.status] }}
                                                        </div>
                                                    </td>
                                                    <td>
                                                        {{
                                                            item.percent_results >= 0 && item.percent_results !== null ? item.percent_results + '%' : 'Chưa có'
                                                        }}
                                                    </td>
                                                    <td>
                                                        <div class="d-flex justify-content-center">
                                                            <button v-if="checkShowButton(item)" class="btn btn-outline-primary p-0 mr-1"
                                                                    title="Xem kết quả" type="button"
                                                                    @click="dialogView(item)"><i
                                                                class="el-icon-view p-2"></i></button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </template>
                                            <template v-else>
                                                <tr class="text-center">
                                                    <td colspan="7">
                                                        Không có dữ liệu
                                                    </td>
                                                </tr>
                                            </template>
                                        </tbody>
                                    </table>
                                </div>
                                <div class="position-absolute mt-3" style="right: 40px;"> Tổng số bản ghi: <b
                                    style="color: rgb(54, 153, 255);">{{
                                        data?.details?.total ? data?.details?.total : 0
                                    }}</b></div>
                            </div>
                        </div>
                        <div class="edu-paginate mx-auto d-flex justify-content-center">
                            <paginate v-model="page" :click-handler="clickCallback" :container-class="'pagination b-pagination'" :margin-pages="1"
                                      :next-class="'page-link'"
                                      :next-link-class="'next-link-item'" :next-text="'Sau'"
                                      :page-class="'page-item'" :page-count="pageCount"
                                      :page-range="3" :pageLinkClass="'page-link'"
                                      :prev-class="'page-link'"
                                      :prev-link-class="'prev-link-item'" :prev-text="'Trước'">
                            </paginate>
                        </div>
                    </div>
                    <el-dialog :visible.sync="showDialogEdit" title="Thành phẩm KRA">
                        <ResultKraComponent
                            :clearResult="isClearResult" :data="dataResult"
                            :month="month" :showDialogEdit="showDialogEdit"
                            @close="closeDialog"
                        />
                    </el-dialog>
                </div>
                <Fireworks v-if="showFireworks"/>
            </div>

            <el-dialog :visible.sync="dialogDetailResultKip" title="Kết quả KRA chi tiết" width="70%">
                <ResultDetailComponent :dataDetail="dataView" :is_link="is_link" />
            </el-dialog>
            <el-dialog :visible.sync="showNotification" title="Thông báo" width="30%" @close="closeFireworks" :show-close="false">
                <span style="word-break: break-word">
                    {{
                        isHappy
                            ? 'Chúc mừng bạn đã xuất sắc hoàn thành 100% KRA'
                            : 'Chúc mừng bạn đã hoàn thành KRA, nhưng hãy nỗ lực hoàn thành 100% bạn nhé'
                    }}
                </span>
                <div class="d-flex justify-content-center mt-4">
                    <el-button size="small" @click="closeFireworks" type="info">Đóng</el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import ResultKraComponent from "../component/ResultKraComponent.vue"
import ResultDetailComponent from "../component/ResultDetailComponent.vue"
import {UPDATE_DATA_KPI_PERSIONAL} from "@/core/services/store/kpi/kpi.module";
import { debounce } from 'lodash-es'
import Fireworks from "@/views/pages/common/Fireworks.vue";

export default {
    components: {
        Fireworks,
        ResultKraComponent,
        ResultDetailComponent
    },
    props: {
        data: {
            type: [Array, Object],
            default: () => []
        },
        month: {
            type: String,
            default: ''
        },
        pageCount: {
            type: Number,
            default: 0
        },
    },

    data() {
        return {
            page: 1,
            last_page: 1,
            textarea: '',
            dataResult: [],
            dataView: '',
            isClearResult: false,
            is_link: false,
            showDialogEdit: false,
            dialogDetailResultKip: false,
            loading: false,
            statusKpiCss: {
                0: "background-color: rgba(255, 0, 0, 1); text-white",
                1: "background-color: rgba(0, 128, 13, 1); text-white",
            },
            statusKpi: {
                0: "Cần nhập",
                1: "Đã nhập",
            },
            itemsChange: [],
            initialResults: {},
            resultsError: {},
            resultsSuccess: {},
            dataKraClone: [],
            showFireworks: false,
            showNotification: false,
            isHappy: false
        }
    },
    // mounted() {
    //     this.checkShowFireworks()
    // },
    watch: {
        'data.details.data': {
            immediate: true,
            handler(newVal) {
                newVal?.forEach(item => {
                    this.$set(this.initialResults, item.id, item.results);
                });
                this.checkShowFireworks()
            },
        }
    },

    methods: {
        clearResult() {
            this.resultsError = []
            this.resultsSuccess = []
        },
        debouncedChangeResult: debounce(function (item, value, id) {
            if (value.trim() === '') {
                this.$set(this.resultsError, id, 'Thành phẩm không được để trống');
            } else {
                this.changeResult(item, value, id);
            }
        }, 1000), // delay 300ms
        changeResult(item, value, id) {
            const originalValue = this.initialResults[id];
            if (value === originalValue) {
                this.itemsChange = this.itemsChange.filter(itemId => itemId !== id);
            } else {
                if (!this.itemsChange.includes(id)) {
                    this.itemsChange.push(id);
                }
            }
            delete this.resultsError[id];
            delete this.resultsSuccess[id];
            this.saveResult(id, value, item)
        },
        dialogView(item) {
            const urlPattern = /(https?:\/\/[^\s]+)/g;
            let results = item.results;
            if (results) {
                results = results.replace(urlPattern, (url) => {
                    return `<a href="${url}" class="styled-link">${url}</a>`;
                });
            }
            this.dataView = item;
            this.is_link = this.isLink(item);
            this.dialogDetailResultKip = true;
        },
        saveResult(id, results, item) {
            this.$store.dispatch(UPDATE_DATA_KPI_PERSIONAL, {
                kra_id: id,
                result: results
            }).then((res) => {
                this.initialResults[id] = results;
                item.status = 1
                this.itemsChange = this.itemsChange.filter(itemId => itemId !== id);
                this.$set(this.resultsSuccess, id, 'Nhập thành phẩm thành công');
            }).catch((error) => {
                this.$set(this.resultsError, id, error.data.message ?? '');
            })
        },

        checkShowFireworks() {
            if (this.data?.details?.data?.length > 0) {
                this.dataKraClone = [...this.data?.details?.data]
                if (this.dataKraClone?.filter(item => item?.status_leader === 2).length === this.dataKraClone?.length) {
                    this.showFireworks = true
                    this.showNotification = true
                }
                if (this.dataKraClone?.filter(item => +item?.percent_results === 100)?.length === this.dataKraClone?.length) {
                    this.isHappy = true
                }
            }
        },

        closeFireworks() {
            setTimeout(() => {
                this.showFireworks = false;
            }, 2000)
            this.showNotification = false;
            setTimeout(() => {
                this.isHappy = false;
            }, 300)
        },

        isLink(item) {
            let is_link = item.results ?? "";
            if (!item) {
                this.$notify.error({
                    title: "Thất bại",
                    message: "Chưa có yêu cầu thành phẩm!",
                    type: "error",
                });
                return;
            }
            const urlRegex = /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(:\d+)?(\/[^\s]*)?$/;
            return urlRegex.test(is_link);
        },

        clickCallback(obj) {
            this.$emit('emit', obj);
        },

        closeDialog(is_reload) {
            if (is_reload) {
                this.$emit('emit')
            }
            this.showDialogEdit = false;
        },
        checkShowButton(item) {
            const result = Object.values(item.kra_manager_weeks).some(function (item) {
                return item.percent_results !== null;
            });

            if (result) {
                return true
            }
        }
    }
}
</script>

<style>
#KpiJobStaffComponent .el-textarea__inner {
    word-break: break-word;
    min-height: 37px !important;
}

#KpiJobStaffComponent .link {
    color: rgb(0, 153, 255) !important;
    text-decoration: underline !important;
}

#KpiJobStaffComponent .link:hover {
    cursor: pointer;
    color: blue !important;
    text-decoration: underline !important;
}

#KpiJobStaffComponent .text-color {
    color: rgba(69, 70, 116, 1);
}

#KpiJobStaffComponent .input.el-input__inner .bg-sivel {
    background-color: red !important;
}

.header-kra {
    text-align: center;
}

#KpiJobStaffComponent .el-dialog__body {
    padding: 10px 20px;
}

#KpiJobStaffComponent .btn-outline-warning {
    color: rgb(246, 148, 0);
    outline: rgb(246, 148, 0);
}

#KpiJobStaffComponent .btn-outline-primary {
    color: rgba(0, 26, 114, 1);
    outline: rgba(0, 26, 114, 1);
}

.btn-outline-primary:hover {
    color: #ffff;
    background-color: rgb(92, 201, 232);
    border-color: rgb(92, 201, 232);
}


#KpiJobStaffComponen .btn-outline-warning {
    color: rgba(255, 153, 0, 1);
    border-color: rgba(255, 153, 0, 1);
}

.btn-outline-warning:hover {
    color: #000 !important;
    background-color: rgba(255, 153, 0, 1);
    border-color: rgba(255, 153, 0, 1);
}

.bg-dangerr {
    background-color: rgba(255, 0, 0, 1);
}

.bg-successs {
    background-color: rgba(10, 129, 0, 1);
}
.breaking-text {
    white-space: pre-wrap;
}
</style>


